import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _div;

import React from 'react';
import styled from 'styled-components';
export var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  transform: translate(-50%, -50%);\n  height: ", ";\n  width: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  & .marker-bg {\n    height: 100%;\n    width: 100%;\n    background-color: #028EFF;\n    border-radius: 100%;\n    opacity: 0.15;\n    position: absolute;\n  }\n  &::after {\n    content: '';\n    border-radius: 100%;\n    border: 5px solid #028EFF;\n    background-color: white;\n    position: relative;\n    height: ", ";\n    width: ", ";\n  }\n"])), function (props) {
  return props.outerHeight;
}, function (props) {
  return props.outerWidth;
}, function (props) {
  return props.height;
}, function (props) {
  return props.width;
});

var ActiveMarker = function ActiveMarker(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? '30px' : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '30px' : _ref$width,
      _ref$outerHeight = _ref.outerHeight,
      outerHeight = _ref$outerHeight === void 0 ? '60px' : _ref$outerHeight,
      _ref$outerWidth = _ref.outerWidth,
      outerWidth = _ref$outerWidth === void 0 ? '60px' : _ref$outerWidth;
  return /*#__PURE__*/React.createElement(Wrapper, {
    height: height,
    width: width,
    outerHeight: outerHeight,
    outerWidth: outerWidth
  }, _div || (_div = /*#__PURE__*/React.createElement("div", {
    className: "marker-bg"
  })));
};

export default ActiveMarker;